import { useCallback } from 'react';
import { useRelayEnvironment } from 'react-relay';
import { commitLocalUpdate } from 'relay-runtime';

/**
 * Commits a local update to the Relay store with the updated column isFrozen (i.e. field set preferences)
 * @param connectionId ID of the `JiraIssueSearchFieldSetConnection` record
 */
export const useColumnIsFrozenUpdater = (connectionId: string) => {
	const environment = useRelayEnvironment();

	return useCallback(
		(updatedColumns: { fieldSetId: string; isFrozen: boolean }[]) => {
			commitLocalUpdate(environment, (store) => {
				const connection = store.get(connectionId);
				if (!connection) {
					return;
				}

				const fieldSetEdges = connection.getLinkedRecords('edges') ?? [];

				updatedColumns.forEach(({ fieldSetId, isFrozen }) => {
					const fieldSetEdge = fieldSetEdges.find((edge) => {
						const id = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
						return fieldSetId === id;
					});

					if (!fieldSetEdge) {
						return;
					}

					const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
					if (!fieldSetNode) {
						return;
					}

					const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord(
						'fieldSetPreferences',
						'JiraFieldSetPreferences',
					);

					fieldSetPreferences.setValue(isFrozen, 'isFrozen');
				});
			});
		},
		[connectionId, environment],
	);
};
